import React, { createContext, useState } from 'react';

// CONTEXT
export const AdjustedPriceContext = createContext(null);

// MAIN COMPONENT
const PriceAdjustmentWrapper = ({
  children
}) =>{

  // STATE
  const [ adjustedPrice, setAdjustedPrice ] = useState();

  return <AdjustedPriceContext.Provider
    value={{
      adjustedPrice,
      setAdjustedPrice
    }}
  >{children}</AdjustedPriceContext.Provider>;
}

// EXPORT
export default PriceAdjustmentWrapper
